module.exports = __webpack_public_path__ + "static/avatar_zach-d55abd481dc44c75c768c709e64e4db8.png";